var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"profile-pages"}},[_c('div',{staticClass:"profile-content"},[_c('Menu'),_c('div',{staticClass:"main-profile"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }